function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/admin/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const AdminRoutes = [
  {
    path: '/admin/dashboard',
    component: view('Dashboard'),
    name: 'admin.dashboard',
    authorizedRole: 'admin'
  },
  {
    path: '/admin/accounts/users',
    component: view('UserAccounts'),
    name: 'admin.accounts.users',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/accounts/employees',
    component: view('EmployeeAccounts'),
    name: 'admin.accounts.employees',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Employees',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/banks',
    component: view('Banks'),
    name: 'admin.maintenances.banks',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Banks',
          active: true
        }
      ]
    }
  }
]

export default AdminRoutes
